export interface SearchReserveGroupRequest {
  key: string
}

export function SearchReserveGroupRequestToJSON(
  value: SearchReserveGroupRequest
): any {
  return {
    key: value.key !== '' ? value.key : undefined
  }
}
